import {handleActions} from 'redux-actions';

const INITIAL_STATE = {
  isFetching: false,
  announcements: [],
  lastFetch: null,
};

const fetchAnnouncements = (state) => ({
  ...state,
  isFetching: true,
  lastFetch: Date.now(),
});

const receiveAnnouncements = (state, {payload}) => {
  if (payload) {
    return {...state, isFetching: false, announcements: payload};
  }
  return INITIAL_STATE;
};
const clearAnnouncementsData = (/* state, action */) => INITIAL_STATE;

export default handleActions({fetchAnnouncements, receiveAnnouncements, clearAnnouncementsData}, INITIAL_STATE);